import { getApi } from '../../../api';

export async function loginUser(user) {
  try {
    const response = await getApi().post('/auth/sign_in', { user }, '');

    return response;
  } catch (e) {
    // console.log('e:')
    return { status: e.status };
  }
}

export async function getUser(id) {
  try {
    const response = await getApi().get(`/users/${id}`, { data: {} });

    return response;
  } catch (e) {
    return { status: e.status };
  }
}
